import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPower = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.3228 2.05351C14.7596 2.20247 15.0377 2.63095 14.9959 3.09051L14.4587 8.99998H17C17.365 8.99998 17.701 9.19882 17.8766 9.51877C18.0522 9.83871 18.0396 10.2289 17.8437 10.5369L10.8437 21.5368C10.5959 21.9262 10.1139 22.0954 9.67719 21.9464C9.24044 21.7975 8.96233 21.369 9.00411 20.9094L9.54133 15H7C6.63502 15 6.29903 14.8011 6.12339 14.4812C5.94776 14.1612 5.96039 13.771 6.15634 13.4631L13.1563 2.4631C13.4041 2.07379 13.8861 1.90455 14.3228 2.05351ZM8.82167 13H10.6364C10.9173 13 11.1853 13.1182 11.3748 13.3256C11.5642 13.5331 11.6577 13.8107 11.6323 14.0905L11.369 16.986L15.1783 11H13.3636C13.0827 11 12.8147 10.8818 12.6252 10.6743C12.4358 10.4668 12.3423 10.1892 12.3677 9.90944L12.631 7.01394L8.82167 13Z",
		fill: "currentColor"
	})
});
export default SvgPower;
